import { lazy } from 'react';
import type { AppModule } from '@/app/module-registry';

const SearchPage = lazy(() => import('./SearchPage'));
const ListingDetailPage = lazy(() => import('./ListingDetailPage'));

/**
 * Catalogo publico. As rotas seguem os padroes de URL do Cap. 27.1 — as
 * variantes por estado e cidade existem para o SEO e caem na mesma tela de
 * busca, com os filtros pre-aplicados pelo loader do backend.
 */
export const catalogModule: AppModule = {
  key: 'catalog',
  order: 10,
  routes: [
    { path: 'lotes', element: <SearchPage /> },
    { path: 'lotes/:state', element: <SearchPage /> },
    { path: 'lotes/:state/:city', element: <SearchPage /> },
    { path: 'terrenos/:city', element: <SearchPage /> },
    { path: 'anuncio/:slug', element: <ListingDetailPage /> },
  ],
};
